import React from "react";
import { useParams } from "react-router-dom";
import SubmissionForm from "./SubmissionForm";

const projects = {
  1: {
    title: "Python ile Hava Durumu API’si Uygulaması",
    description:
      "Bu projede bir hava durumu API'si kullanarak şehir bazlı veri çekilecek.",
    requirements: ["Python", "Requests", "API bilgisi"],
    submission: ["GitHub linki", "Dosya yükleme"],
  },
  2: {
    title: "SQL ile Müşteri Segmentasyonu",
    description: "Kullanıcı verileri ile segmentasyon analizi yapılacak.",
    requirements: ["SQL", "Veri analizi", "JOIN, GROUP BY"],
    submission: ["SQL dosyası", "GitHub linki"],
  },
  3: {
    title: "React ile Basit Todo Uygulaması",
    description:
      "React ile CRUD işlemleri yapan bir todo uygulaması geliştirilecek.",
    requirements: ["React", "useState", "JSX"],
    submission: ["GitHub linki", "Canlı demo"],
  },
  4: {
    title: "Pandas ile Veri Temizleme Görevi",
    description:
      "Ham verileri temizleyip analiz için hazır hale getirme çalışması.",
    requirements: ["Python", "Pandas", "Veri ön işleme"],
    submission: ["Jupyter Notebook", "GitHub linki"],
  },
};

export default function PDetail() {
  const { id } = useParams();
  const project = projects[id];

  if (!project) {
    return <div className="p-6 text-red-500">Proje bulunamadı.</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h1 className="text-2xl font-bold mb-4">{project.title}</h1>
      <p className="mb-4">{project.description}</p>

      <h2 className="text-xl font-semibold mt-4">Gereksinimler</h2>
      <ul className="list-disc pl-6 mb-4">
        {project.requirements.map((req, index) => (
          <li key={index}>{req}</li>
        ))}
      </ul>

      <h2 className="text-xl font-semibold mt-4">Teslim Formatı</h2>
      <ul className="list-disc pl-6 mb-4">
        {project.submission.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 className="text-xl font-semibold mt-4">Geri Bildirim</h2>
      <p>
        Bu proje tamamlandığında mentorlar ve yapay zeka tarafından
        değerlendirilecektir.
      </p>

      <SubmissionForm projectId={id} />
    </div>
  );
}
